import { ReactNode, useState } from 'react';
import { BottomMenu } from '../Menu';
import { Header, ShellContext } from './Header';
import styles from './Shell.module.css';
import { Subscribe } from '@react-rxjs/core';
import { LFC } from '../../types';

interface ShellProps {}

export const Shell: LFC<ShellProps> = (props) => {
  const { children } = props;
  const content = useState<ReactNode | null>(null);
  const title = useState<ReactNode | null>(null);
  const rightContent = useState<ReactNode | null>(null);
  const mini = useState(false);
  const hideMenu = useState(false);

  return (
    <Subscribe fallback={null}>
      <div className={styles.shell}>
        <ShellContext.Provider
          value={{ mini, content, title, hideMenu, rightContent }}
        >
          <Header />
          {children}
          <BottomMenu />
        </ShellContext.Provider>
      </div>
    </Subscribe>
  );
};
